module.exports = __webpack_public_path__ + "static/media/order.35f768d2.svg";